<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../../assets/images/patch/aboutUsBg.png">
    </div>
    <div class="bgMobileImageWrap">
        <img src="../../../../assets/images/aboutUsMobileBg.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
              About Us
            </div>
          <!--   <div class="subTitleWrap">
               Our featured services
            </div> -->
            <div class="knowMoreWrap">
               <!--  <div class="buttonWrap">
                    <button>
                        KNOW MORE
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</div>


<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
        <div class="titleWrap">
                Innovative. Challenging. Reliable.
            </div> 
            <div class="descWrap">
                Being a Design-First company, IT IS IN OUR DNA TO MAKE PRODUCTS THAT LOOK THE BEST AND WORK EVEN BETTER. We specialize in mobile and web development, design creation, DevOps solutions and Staff Augmentation. We do believe in approaching every project no matter how creative and challenging your idea is. Combining our tech expertise with your business needs we ensure that your business will have a profitable competitive advantage.
            </div>
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <div class="textWrap">
                    <span class="titleRowWrap">
                       {{i.title}}
                    </span>
                    <span class="spanClass">+</span>
                    <span class="descRowWrap">
                       {{i.desc}}
                    </span>
                </div>

               <!--   <div class="card">
                   <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div> 
                  
                </div>-->
            </div>
        </div>
    </div>
</div>